import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniahireinpimprichichwad() {



    const cardData =
    {
        keyword: 'Urbania Hire in Pimpri for Corporate Travel',
        heading: 'Urbania on rent in pune: Urbania Hire in Pimpri for Corporate Travel',
        headingDescription: 'Urbania On Rent in Pune offers premium and reliable Urbania Hire in Pimpri for Corporate Travel for companies, business professionals, and corporate groups requiring comfortable and efficient transportation. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, ample luggage space, and smooth performance, making it ideal for office commutes, client meetings, conferences, employee transportation, airport transfers, and outstation corporate travel from Pimpri. With professional, well-trained chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from Pimpri, Chinchwad, Akurdi, Nigdi, Bhosari, Hinjewadi, and Pune Airport, we ensure punctual and hassle-free corporate movement. Backed by 24/7 booking support, transparent pricing, and dependable service, Urbania On Rent in Pune stands out as the trusted choice for corporate Urbania hire in Pimpri.',

        top: 'Top Places to Visit in Pune with Pune on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort and a symbol of Maratha glory. Known for its massive stone walls, grand gateways like Delhi Darwaza, and lush lawns, it served as the seat of Bajirao I’s administration. Despite being partially destroyed by fire, the remnants echo royal grandeur. Evening light-and-sound shows vividly bring Maratha history to life, making it a must-visit heritage site."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, Aga Khan Palace is a historical monument linked to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum with Gandhi’s personal artifacts, photographs, and the samadhis of Kasturba and Mahadev Desai. Its sprawling gardens, Italian arches, and tranquil ambiance make it a symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The temple trust is known for charitable work. Devotees find immense peace and blessings here, making it the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop a rugged hill, Sinhagad Fort is famous for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive to explore ancient ramparts, memorials, and scenic viewpoints. Local vendors offer traditional pithla-bhakri meals near the summit. The fort provides panoramic views of the Sahyadri ranges, blending history, adventure, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars, a circular Nandi pavilion, and a peaceful sanctum. Despite being in a busy area, it maintains a tranquil spiritual ambiance. Its ancient carvings showcase early Indian craftsmanship, making it Pune’s hidden heritage retreat."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, representing India’s rich cultural past. From traditional ornaments and musical instruments to household antiques and sculptures, it is a treasure trove of heritage. The recreated Mastani Mahal is a highlight, making it Pune’s living archive of art, craftsmanship, and history."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic city views after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add cultural charm. Sunrise and sunset visits are especially mesmerizing, making Parvati Hill a spiritual and scenic highlight."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation and spiritual transformation, making it Pune’s international retreat for tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Featuring flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers, it is ideal for families, photography enthusiasts, and peaceful strolls. The garden blends Japanese aesthetics with Indian nature, serving as Pune’s serene green sanctuary."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot for locals. The vast waterscape and surrounding hills create picturesque views, especially during monsoon. Street vendors sell roasted corn and tea, adding local flavor. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy weekend escape and sunset viewpoint."
  }
],




"services": [
{
"name": "Urbania Hire in Pimpri for Corporate Travel",
"description": "Urbania Hire in Pimpri for Corporate Travel provides professional and well-organized transportation solutions for companies and business groups. The Urbania buses are spacious, clean, and designed for daily and occasional corporate travel, offering comfortable seating and ample legroom. With experienced chauffeurs, punctual pickups, and reliable service, this option ensures smooth and stress-free travel for employees, executives, and corporate guests. It is ideal for office commutes, meetings, conferences, and business tours within and outside Pimpri."
},
{
"name": "Corporate Urbania Hire Pimpri",
"description": "Corporate Urbania Hire Pimpri offers dependable Urbania bus rental services tailored specifically for corporate requirements. The service focuses on professionalism, safety, and punctuality, ensuring employees and management travel comfortably and on time. Well-maintained buses with clean interiors and AC options make long and short journeys pleasant. This service is suitable for daily employee transport, corporate events, and official travel from Pimpri to various destinations."
},
{
"name": "Urbania for Office Commute Pimpri",
"description": "Urbania for Office Commute Pimpri provides efficient and comfortable transportation for daily office travel. The buses are designed to handle regular commutes with ease, offering comfortable seating, clean interiors, and smooth ride quality. Professional drivers follow fixed schedules and safe driving practices, ensuring employees reach the office and return home on time. This service helps companies manage employee transportation reliably and conveniently."
},
{
"name": "Employee Transport Urbania Pimpri",
"description": "Employee Transport Urbania Pimpri delivers safe and organized transport solutions for staff members working in Pimpri and nearby areas. The service ensures timely pickups and drops, reducing commute stress for employees. With spacious seating, AC options, and trained chauffeurs, the Urbania buses provide a secure and comfortable daily travel experience, making it suitable for IT companies, factories, and corporate offices."
},
{
"name": "Urbania AC Corporate Bus Pimpri",
"description": "Urbania AC Corporate Bus Pimpri offers fully air-conditioned buses for a comfortable and climate-controlled corporate travel experience. These buses are ideal for long commutes, meetings, and business tours, ensuring employees remain relaxed throughout the journey. Clean interiors, comfortable seating, and experienced drivers contribute to a premium and professional travel environment for corporate passengers."
},
{
"name": "Monthly Corporate Urbania Rental Pimpri",
"description": "Monthly Corporate Urbania Rental Pimpri provides cost-effective and reliable long-term rental solutions for companies requiring daily or regular transportation. This service is ideal for office commutes and employee transport, offering consistent service, dedicated vehicles, and trained drivers. Companies benefit from predictable schedules, reduced transportation management efforts, and dependable travel arrangements for their workforce."
},
{
"name": "Chauffeur Driven Corporate Urbania Pimpri",
"description": "Chauffeur Driven Corporate Urbania Pimpri ensures a hassle-free corporate travel experience with professional and verified drivers. The chauffeurs are experienced in handling city traffic and corporate schedules, ensuring punctual and safe journeys. Passengers can focus on work or relaxation while enjoying comfortable seating, clean buses, and reliable service throughout their travel."
},
{
"name": "Reliable Corporate Urbania Service Pimpri",
"description": "Reliable Corporate Urbania Service Pimpri is known for its consistency, punctuality, and customer-focused approach. The service offers well-maintained Urbania buses with professional drivers who understand corporate travel requirements. It is suitable for daily employee transport, business meetings, and corporate events, ensuring smooth and dependable transportation every time."
},
{
"name": "Affordable Corporate Urbania Hire Pimpri",
"description": "Affordable Corporate Urbania Hire Pimpri provides budget-friendly corporate transport solutions without compromising on comfort or safety. The buses are spacious, clean, and reliable, making them suitable for small and large corporate teams alike. This service is ideal for companies seeking cost-effective yet professional transportation for employees and official travel."
},
{
"name": "Urbania for IT Companies Pimpri",
"description": "Urbania for IT Companies Pimpri offers specialized transport solutions for IT firms and tech parks in and around Pimpri. The service supports shift-based travel, daily commutes, and corporate outings with punctual schedules and reliable buses. Comfortable seating, AC options, and experienced drivers ensure employees travel safely and comfortably every day."
},
{
"name": "Corporate Event Urbania Pimpri",
"description": "Corporate Event Urbania Pimpri provides organized transportation for conferences, seminars, meetings, and corporate gatherings. The buses ensure timely arrival of participants and smooth coordination between venues. With professional chauffeurs, clean interiors, and comfortable seating, this service enhances the overall corporate event experience."
},
{
"name": "Best Corporate Urbania Rental Pimpri",
"description": "Best Corporate Urbania Rental Pimpri is a trusted choice for companies looking for high-quality buses and dependable service. The Urbania vehicles are regularly maintained and equipped for corporate travel, offering comfort, safety, and punctuality. This service caters to daily commutes, business travel, and special corporate requirements."
},
{
"name": "Professional Corporate Urbania Hire Pimpri",
"description": "Professional Corporate Urbania Hire Pimpri focuses on delivering premium and organized transport solutions for businesses. The service emphasizes disciplined operations, trained drivers, and clean vehicles to meet corporate standards. It is ideal for executive travel, employee transport, and official group movements."
},
{
"name": "Business Travel Urbania Pimpri",
"description": "Business Travel Urbania Pimpri offers comfortable and efficient transportation for executives and business teams traveling for meetings, site visits, and official tours. The buses provide a relaxed environment with spacious seating and professional drivers, ensuring productive and stress-free travel for business purposes."
},
{
"name": "Corporate Group Travel Urbania Pimpri",
"description": "Corporate Group Travel Urbania Pimpri provides spacious and reliable buses for transporting large corporate groups together. The service ensures coordinated travel with ample seating, luggage space, and professional chauffeurs. It is ideal for team outings, training programs, conferences, and corporate tours from Pimpri."
}
],
"tableData": [
["Urbania Hire in Pimpri for Corporate Travel", "Corporate Urbania Hire Pimpri"],
["Urbania for Office Commute Pimpri", "Employee Transport Urbania Pimpri"],
["Urbania AC Corporate Bus Pimpri", "Monthly Corporate Urbania Rental Pimpri"],
["Chauffeur Driven Corporate Urbania Pimpri", "Reliable Corporate Urbania Service Pimpri"],
["Affordable Corporate Urbania Hire Pimpri", "Urbania for IT Companies Pimpri"],
["Corporate Event Urbania Pimpri", "Best Corporate Urbania Rental Pimpri"],
["Professional Corporate Urbania Hire Pimpri", "Business Travel Urbania Pimpri"],
["Corporate Group Travel Urbania Pimpri", ""]
],



whychoose : [
    {
        "WhyChooseheading": "Urbania Hire in Pimpri for Corporate Travel",
        "WhyChoosedescription": "Urbania Hire in Pimpri for Corporate Travel is the perfect choice for employee commutes, corporate events, business meetings, airport transfers, and team outings with comfort and reliability."
    },
    {
        "WhyChooseheading": "Spacious and Professional Urbania Buses",
        "WhyChoosedescription": "Our Urbania buses in Pimpri are equipped with air-conditioning, comfortable seating, ample legroom, and adequate luggage space to ensure a smooth and productive corporate journey."
    },
    {
        "WhyChooseheading": "Experienced and Punctual Drivers",
        "WhyChoosedescription": "All drivers are trained, licensed, and experienced in corporate travel routes, ensuring timely pickups, safe driving, and stress-free transfers."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Urbania Hire in Pimpri for Corporate Travel offers competitive pricing with no hidden charges, making corporate transportation cost-effective and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "We provide round-the-clock booking assistance and dedicated support for inquiries, reservations, and last-minute corporate travel needs."
    },
    {
        "WhyChooseheading": "Flexible Corporate Travel Packages",
        "WhyChoosedescription": "Available for daily employee shuttles, event transfers, airport pickups, outstation meetings, and customized corporate schedules."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania buses are regularly cleaned, sanitized, and maintained to ensure passenger comfort, hygiene, and safety."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Corporate Service",
        "WhyChoosedescription": "Our Urbania Hire in Pimpri for Corporate Travel guarantees on-time service, dependable support, and a seamless travel experience."
    }
]
}
const faqData = [
    {
        question: 'Can Urbania Hire in Pimpri for Corporate Travel be booked for daily shuttles?',
        answer: 'Yes, it can be booked for daily employee shuttles, business events, airport transfers, and team outings.'
    },
    {
        question: 'How can I book Urbania Hire in Pimpri for Corporate Travel?',
        answer: 'Bookings can be made via phone, WhatsApp, or online for quick and convenient reservations.'
    },
    {
        question: 'Why choose Urbania Hire in Pimpri for Corporate Travel?',
        answer: 'This service offers comfortable seating, professional drivers, clean vehicles, flexible corporate packages, and transparent pricing.'
    },
    {
        question: 'Are drivers experienced with corporate routes?',
        answer: 'Yes, all drivers are trained and familiar with Pimpri city routes and corporate travel requirements.'
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Absolutely. Flexible pickup and drop-off points are available across Pimpri and nearby areas.'
    },
    {
        question: 'Is Urbania Hire in Pimpri for Corporate Travel available 24/7?',
        answer: 'Yes, booking services and customer support are available 24/7.'
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are thoroughly cleaned, sanitized, and well-maintained for passenger safety.'
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Payments can be made via UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing.'
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout your corporate travel.'
    },
    {
        question: 'Is this service suitable for corporate teams of all sizes?',
        answer: 'Yes, Urbania Hire in Pimpri for Corporate Travel is ideal for teams, employees, executives, and business groups.'
    }
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Vikram Joshi',
        feedback: 'Urbania Hire in Pimpri made our company’s corporate travel extremely smooth. Professional drivers and comfortable buses ensured a stress-free experience.',
        rating: 5
    },
    {
        id: 2,
        name: 'Ms. Neha Rane',
        feedback: 'Great service for our team outing. The Urbania bus was on time, clean, and perfect for corporate travel. Highly recommended!',
        rating: 5
    }
];

















































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Hire in Pimpri for Corporate Travel",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-pimpri-corporate.jpg",
  "description": "Urbania Hire in Pimpri for Corporate Travel offers AC Urbania buses for office commutes, employee transport, corporate events, and group business travel. Chauffeur-driven Urbania buses ensure safe, comfortable, and convenient transportation for corporate clients in Pimpri, Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-hire-in-pimpri-for-corporate-travel"
  }
};




    return (
        <div>

<Helmet>
  <title>
    Call:+91 9209423113 | Urbania Hire in Pimpri for Corporate Travel | AC Corporate Urbania Bus 
  </title>

  <meta
    name="description"
    content="Book Urbania Hire in Pimpri for Corporate Travel for office commutes, employee transport, corporate events, and group business travel. AC chauffeur-driven Urbania buses provide safe, comfortable, and convenient transportation for corporate clients in Pimpri, Pune."
  />

  <meta
    name="keywords"
    content="Urbania Hire in Pimpri for Corporate Travel, Corporate Urbania Hire Pimpri, Urbania for Office Commute Pimpri, Employee Transport Urbania Pimpri, Urbania AC Corporate Bus Pimpri, Monthly Corporate Urbania Rental Pimpri, Chauffeur Driven Corporate Urbania Pimpri, Reliable Corporate Urbania Service Pimpri, Affordable Corporate Urbania Hire Pimpri, Urbania for IT Companies Pimpri, Corporate Event Urbania Pimpri, Best Corporate Urbania Rental Pimpri, Professional Corporate Urbania Hire Pimpri, Business Travel Urbania Pimpri, Corporate Group Travel Urbania Pimpri"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/113.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniahireinpimprichichwad;